import React, { useEffect, useState } from 'react';
import { concernsAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';

const STATUS_COLOR = { pending: 'orange', acknowledged: 'blue', in_progress: 'purple', resolved: 'green' };

export default function EmployeeConcerns() {
  const [concerns, setConcerns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ type: 'concern', title: '', content: '', is_confidential: false });
  const [error, setError] = useState('');

  const load = () => concernsAPI.list().then(({ data }) => setConcerns(data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await concernsAPI.create(form);
      setShowForm(false);
      setForm({ type: 'concern', title: '', content: '', is_confidential: false });
      load();
    } catch (err) {
      setError(parseApiError(err, 'Submission failed'));
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>Concerns &amp; Suggestions</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Submit New'}
        </button>
      </div>

      {showForm && (
        <div className="form-card mb-6">
          <h3>New Submission</h3>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Type</label>
                <select value={form.type} onChange={set('type')}>
                  <option value="concern">Concern</option>
                  <option value="suggestion">Suggestion</option>
                </select>
              </div>
              <div className="form-group flex-row-center">
                <input type="checkbox" id="confidential" checked={form.is_confidential} onChange={set('is_confidential')} />
                <label htmlFor="confidential" style={{ marginLeft: 8 }}>Mark as Confidential</label>
              </div>
            </div>
            <div className="form-group">
              <label>Title *</label>
              <input required value={form.title} onChange={set('title')} />
            </div>
            <div className="form-group">
              <label>Details *</label>
              <textarea required rows={4} value={form.content} onChange={set('content')} />
            </div>
            <div className="form-actions">
              <button type="button" className="btn btn-ghost" onClick={() => setShowForm(false)}>Cancel</button>
              <button type="submit" className="btn btn-primary">Submit</button>
            </div>
          </form>
        </div>
      )}

      {loading ? <div className="page-loading">Loading...</div> : concerns.length === 0 ? (
        <div className="empty-state">No concerns or suggestions yet.</div>
      ) : (
        <div className="concern-list">
          {concerns.map((c) => (
            <div key={c.id} className="concern-card">
              <div className="concern-header">
                <div>
                  <span className={`badge badge-${c.type === 'suggestion' ? 'blue' : 'orange'}`}>{c.type}</span>
                  {c.is_confidential && <span className="badge badge-gray ml-2">Confidential</span>}
                  <h4>{c.title}</h4>
                </div>
                <span className={`badge badge-${STATUS_COLOR[c.status]}`}>{c.status}</span>
              </div>
              <p className="concern-content">{c.content}</p>
              {c.hr_response && (
                <div className="hr-response">
                  <strong>HR Response:</strong> {c.hr_response}
                </div>
              )}
              <div className="concern-footer">
                <small>{new Date(c.created_at).toLocaleDateString()}</small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
